import axios, { AxiosResponse } from 'axios'

import {
  CSAreaId,
  CSDateId,
  CSDateRead,
  CSDateReservationsRead,
  CSDateWrite,
  PerformanceQueryParams,
} from '@generated/types'

const DATE_BASE = '/api/csdate'

interface ListCSDateParams {
  csarea_id?: CSAreaId
  start_date?: string
  end_date?: string
}

export default {
  async listCSDatesForArea(params: ListCSDateParams): Promise<AxiosResponse<CSDateRead[]>> {
    return axios.get(`${DATE_BASE}/`, { params })
  },

  async getCSDate(csDateId: CSDateId): Promise<AxiosResponse<CSDateRead>> {
    return axios.get(`${DATE_BASE}/${csDateId}/`)
  },

  async getCSDates(query: PerformanceQueryParams): Promise<AxiosResponse<CSDateRead[]>> {
    return axios.get(`${DATE_BASE}/`, { params: query })
  },

  async getCSDateReservationsById(
    csDateId: CSDateId,
  ): Promise<AxiosResponse<CSDateReservationsRead>> {
    return axios.get(`${DATE_BASE}/${csDateId}/reservations/`)
  },

  async getCSDateReservations(
    csareaId: CSAreaId,
    date: string,
  ): Promise<AxiosResponse<CSDateReservationsRead>> {
    return axios.get(`${DATE_BASE}/${csareaId}/${date}/reservations/`)
  },

  async createCSDate(data: CSDateWrite): Promise<AxiosResponse<CSDateRead>> {
    return axios.post(`${DATE_BASE}/`, data)
  },

  async updateCSDate(data: CSDateWrite): Promise<AxiosResponse<CSDateRead>> {
    if (!data.id) throw new Error('CSDate id is required to update.')
    return axios.put(`${DATE_BASE}/${data.id}/`, data)
  },
}
